var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPinwheel = function SvgIconPinwheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.138 6.514a5.88 5.88 0 0 1 4.14.044l-1.34-3.675a1 1 0 0 1 .614-1.288 5.875 5.875 0 0 1 7.39 7.683l3.675-1.34a1 1 0 0 1 1.288.614 5.875 5.875 0 0 1-3.515 7.424l4.317 4.317a1 1 0 0 1-1.414 1.414l-5.382-5.382a5.9 5.9 0 0 1-1.688-.382l1.339 3.674a1 1 0 0 1-.614 1.288 5.875 5.875 0 0 1-7.39-7.683l-3.675 1.34a1 1 0 0 1-1.288-.614 5.875 5.875 0 0 1 3.543-7.434m5.075-3.231 2.42 6.644.012.03.115.316a3.875 3.875 0 0 0-2.547-6.99m2.36 9.351-.03.01-.316.116a3.875 3.875 0 0 0 6.99-2.547zm-2.832-.407.106.293.02.055.01.029 2.41 6.613a3.875 3.875 0 0 1-2.546-6.99m-.986-3.72a3.875 3.875 0 0 0-5.472 3.78l6.99-2.547a3.9 3.9 0 0 0-1.518-1.233",
    clipRule: "evenodd"
  })));
};
export default SvgIconPinwheel;